import React from 'react'
import { isEmpty } from 'lodash'

import { formatDate } from '../../lib/formats'
import PlainText from '../UI/PlainText'

import GraysonLogo from '../../images/grayson-music-logo.svg'
import './styles/printable-quote-headers.css'

/*
Props:
- logoImg: An image to be displayed at the top of the printable Quote/Actual
           default: B/W Grayson logo
- title: The printable quote title (usually QUOTATION, ACTUALS etc.)
- subtitle: Text to place under the title, if any
- docketNumber: Project Docket number to put under the title/subtitle
*/
const LogoHeader = ({ logoImg, title, subtitle, docketNumber }) => (
  <table className="logo-header">
    <tbody>
      <tr>
        <td className="logo-column">
          <img src={logoImg || GraysonLogo} alt="Grayson Matthews" />
        </td>
        <td className="type-column">
          <h2>{title || ''}</h2>
          {subtitle && <h3>{subtitle}</h3>}
          {docketNumber && <h3>Docket {docketNumber}</h3>}
        </td>
      </tr>
    </tbody>
  </table>
)

/*
Props:
- project,
  quote,
  actual,
  agency,
  client,
  agencyProducer,
  user: Complete objects to be displayed in the header. Note that you need to
        provide either a quote or an actual. If both are provided, the actual
        takes precedence.
*/
const ProjectSummary = ({
  project,
  quote,
  actual,
  agency,
  client,
  agencyProducer,
  user
}) => {
  // Figure out if we have a quote or an actual
  const quoteObj = actual || quote

  // Use quoteObj's jobDescription when present,
  // otherwise use project's.
  const jobDescription =
    quoteObj.attributes.jobDescription || project.attributes.jobDescription

  return (
    <header className="project-summary">
      <table>
        <tbody>
          <tr>
            <td>Agency:</td>
            <td className="mid-column">
              {!isEmpty(agency) && agency.attributes.name}
            </td>

            <td className="right-label">Date:</td>
            <td className="right-column">
              {formatDate(quoteObj.attributes.date)}
            </td>
          </tr>

          <tr>
            <td>Client:</td>
            <td className="mid-column">
              {!isEmpty(client) && client.attributes.name}
            </td>

            <td className="right-label">Version:</td>
            <td className="right-column">{quoteObj.attributes.version}</td>
          </tr>

          <tr>
            <td>Contact:</td>
            <td className="mid-column">
              {!isEmpty(agencyProducer) && agencyProducer.attributes.fullName}
            </td>

            <td className="right-label">Prepared by:</td>
            <td className="right-column">
              {!isEmpty(user) && user.attributes.fullName}
            </td>
          </tr>
        </tbody>
      </table>

      <div className="job-summary">
        <h3>{project.attributes.name}</h3>
        <PlainText text={jobDescription} />
      </div>
    </header>
  )
}

const QuoteFooter = ({projectTypeAddress}) => 
{
  return(
    <footer>
      <em>{projectTypeAddress}</em>
    </footer>
  )
}
export { LogoHeader, ProjectSummary, QuoteFooter }



// WEBPACK FOOTER //
// ./src/components/Quotes/PrintableQuoteHeaders.jsx